import { render, staticRenderFns } from "./chinaMap.vue?vue&type=template&id=23a93c2e&scoped=true"
import script from "./chinaMap.vue?vue&type=script&lang=ts"
export * from "./chinaMap.vue?vue&type=script&lang=ts"
import style0 from "./chinaMap.vue?vue&type=style&index=0&id=23a93c2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a93c2e",
  null
  
)

export default component.exports